import React, { useState, useEffect, useRef } from "react";
import MenuIcon from "../Assests/images/Hamburger.png";
import Logo from "../Assests/images/Logo 4.png";
import DropDown from "../Assests/images/tabler-icon-chevron-down.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";

const menuItems = [{ label: "HOME", route: "/" }];
const productContent = [
  { label: "AiWell", route: "https://aiwell.in/" },
  { label: "AiKiosk", route: "/kiosk" },
  { label: "AiDoc", route: "/aidoc" },
];
const ClinicalStudy = [
  { label: "Diabetes / PreDiabetes", route: "/clinicalStudies/diabetes" },
  { label: "Wellness", route: "/clinicalStudies/wellness" },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isClinicalOpen, setIsClinicalOpen] = useState(false);
  const productsDropdownRef = useRef(null);
  const clinicalDropdownRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleProductsDropdown = () => setIsProductsOpen((prev) => !prev);
  const toggleClinicalDropdown = () => setIsClinicalOpen((prev) => !prev);

  const handleClickOutside = (event) => {
    if (
      productsDropdownRef.current &&
      !productsDropdownRef.current.contains(event.target) &&
      clinicalDropdownRef.current &&
      !clinicalDropdownRef.current.contains(event.target)
    ) {
      setIsProductsOpen(false);
      setIsClinicalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="navbar-header sticky top-0 z-10">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src={Logo} alt="Logo" />
        </div>
        <div className="navbar-content">
          {menuItems.map((item) => (
            <div key={item.label} className="navbar-menu-item">
              <Button
                className="navbar-button"
                onClick={() => navigate(item.route)}
              >
                {item.label.charAt(0).toUpperCase() +
                  item.label.slice(1).toLowerCase()}
              </Button>
            </div>
          ))}

          <div className="dropdown-container" ref={productsDropdownRef}>
            <button
              className="dropdown-toggle"
              onClick={toggleProductsDropdown}
            >
              Products
              <img
                src={DropDown}
                alt="Dropdown Icon"
                className="dropdown-icon"
              />
            </button>
            {isProductsOpen && (
              <ul className="dropdown-menu">
                {productContent.map((item) => (
                  <li
                    key={item.label}
                    onClick={() => {
                      setIsProductsOpen(false);
                      if (item.route.startsWith("http")) {
                        window.open(item.route, "_blank");
                      } else {
                        navigate(item.route);
                      }
                    }}
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* <div className="dropdown-container" ref={clinicalDropdownRef}>
          <Link to="/clinical">
            <button className="dropdown-toggle">
              Clinical Study
                
            </button>
            
          </Link>
          <img
                src={DropDown}
                alt="Dropdown Icon"
                className="dropdown-icon mr-2"
                onClick={toggleClinicalDropdown}
              />
            {isClinicalOpen && (
              <ul className="dropdown-menu">
                {ClinicalStudy.map((item) => (
                  <li
                    key={item.label}
                    onClick={() => {
                      setIsClinicalOpen(false);
                      if (item.route.startsWith("http")) {
                        window.open(item.route, "_blank");
                      } else {
                        navigate(item.route);
                      }
                    }}
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            )}
          </div> */}
          <div className="mr-4">
            <Button
              className="navbar-button for-business-button "
              onClick={() => navigate("/clinicalStudies")}
            >
              Clinical Study
            </Button>
          </div>
          
          <div>
            <Button
              className="navbar-button for-business-button"
              onClick={() => navigate("/corporate")}
            >
              For Business
            </Button>
          </div>
        </div>
        <div className="mobile-menu-icon" onClick={toggleMenu}>
          <img src={MenuIcon} alt="Menu Icon" />
        </div>
      </div>
      {menuOpen && (
        <div className="fullscreen-menu" onClick={toggleMenu}>
          <div className="menu-section">
            <div className="close-mobile-menu-icon" onClick={toggleMenu}>
              <CloseIcon />
            </div>
            {menuItems.map((item) => (
              <div key={item.label} className="flex justify-end mt-10">
                <Button
                  className="mobile-menu-text products-title items-end"
                  onClick={() => {
                    navigate(item.route);
                    setMenuOpen(false);
                  }}
                >
                  {item.label.charAt(0).toUpperCase() +
                    item.label.slice(1).toLowerCase()}
                </Button>
              </div>
            ))}
            <ul className="menu-items-section-1">
              <li className="cursor-pointer products-mobile-dropdown">
                <span className="mobile-menu-text products-title mr-3">
                  Products
                </span>
                <ul className="mt-4">
                  {productContent.map((item, index) => (
                    <a
                      key={index}
                      href={item.route}
                      target={
                        item.route.startsWith("http") ? "_blank" : "_self"
                      }
                      rel="noopener noreferrer"
                    >
                      <li className="cursor-pointer mobile-submenu-item items-center mb-3 border-r border-stone-700 mr-5">
                        {item.label}
                      </li>
                    </a>
                  ))}
                </ul>
              </li>
            </ul>
            {/* <ul className="menu-items-section-1">
              <li className="cursor-pointer products-mobile-dropdown">
                <span className="mobile-menu-text products-title mr-3">
                  Clinical Study
                </span>
                <ul className="mt-4">
                  {ClinicalStudy.map((item, index) => (
                    <a
                      key={index}
                      href={item.route}
                      target={item.route.startsWith("http") ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                    >
                      <li className="cursor-pointer mobile-submenu-item items-center mb-3 border-r border-stone-700 mr-5">
                        {item.label}
                      </li>
                    </a>
                  ))}
                </ul>
              </li>
            </ul> */}
            <Button
              className="mobile-menu-button for-business-button mobile-menu-text mb-3 mr-3"
              onClick={() => {
                navigate("/clinicalStudies");
                setMenuOpen(false);
              }}
            >
              Clinical Study
            </Button>
            <Button
              className="mobile-menu-button for-business-button mobile-menu-text mb-3 mr-3"
              onClick={() => {
                navigate("/corporate");
                setMenuOpen(false);
              }}
            >
              For Business
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
